export const QUERY_KEYS = {
  USERS: 'users',
  MY_FANDOMS: 'my_fandoms',
  UNREAD_MESSAGES: 'unread_messages'
};
